const mq_sm = window.matchMedia('(max-width: 49em)');


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

 // elementToFocus.focus();
}


// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}


function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}


function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}


function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}


function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    
    let theQty = Number(this.input.value);
    
   // this.feedQTYtoBtn(theQty);
    
  }
  
  /*
  feedQTYtoBtn(qty) {    
    //console.log(qty)
    document.getElementById('atcBtn').dataset.qty = qty;
  }
  */
  
  
}
customElements.define('quantity-input', QuantityInput);


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) { 
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}


Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};


Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};


Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};


Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};


Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};


Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


class CartFunctions {
   
  constructor() {}
    
  async findItemInCart(id){
    let findAddedItem = await this.getCart();
    let thisID = id;
    let itemFound = findAddedItem.items.filter(itm => itm.variant_id === thisID);        
    if(!itemFound.length) {
      return false;
    } else {  
      return [true,itemFound];
    }    
  }
  
  
  async getCart() {
    // no-store: a cached /cart.json would repaint the drawer (and re-evaluate the
    // free gift) from a stale cart right after a write.
    const result = await fetch("/cart.json", { cache: "no-store" });
    //console.log("result", result);
    if (result.status === 200) {
      return result.json();
    }
    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  }
  
  
  async addItem(id, qty) {  
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: id,
        quantity: qty
      })
    })
    
    return result;
  }

   
  async addItemWithProperties(id, qty, properties = {}) {

    /* 
    === If two line items have identical properties (or no properties), ===============
    === adding an item will just increase the quantity of the existing item. ==========
    === If the properties are not identical, you'll get two separate line items. ======
    ===================================================================================
    */

    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: id,
        quantity: qty,
        properties: properties
      })
    })

    //return cart.json();
  }
  
  
  // Sends id/quantity in the JSON body (same shape as removeItemByID). Passing
  // them as query params with a JSON content-type but no body leaves the cart
  // unchanged — the request "succeeds" while the quantity is silently ignored.
  // Returns the full updated cart.
  async updateItemByID(id, newQty) {
    const result = await fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        'id': `${id}`,
        'quantity': newQty
      })
    });

    return result.json();
  }
  
   
  async updateItemByLine(line_index, newQty, newProperties = null) {

    /* =======================================================================================================================
    === ⚠ If you have two or more items in the cart with the same variant id, ===============================================
    === and you then try to update the quantity by variant id, you will receive an HTTP 400 Bad Request error. ===============
    === You must instead update them using the line method. ==================================================================
    ======================================================================================================================= */

    const payload = { "line": line_index, "quantity": newQty };
    // Only send properties when actually changing them: Shopify replaces the whole
    // property set, so passing an empty object would wipe _free_gift off the line.
    if (newProperties) payload.properties = newProperties;

    const result = await fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(payload)
    });

    return result.json();
  }
  
  
  async removeItemByID(id) {
    
    /* === Se periptwsi error: to change call malakizete me tous eksis tropous: ===
    1) mporei na thelei / not backticks sto url fetch
    2) mporei na thelei / not backticks sto id
    ============================================================================ */
    const result = await fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        'id': `${id}`,
        'quantity': 0
      })
    });

    return result.json();
  }

  
  async removeItemByLine(line_index) {
    const result = await fetch(`/cart/change.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        "line": line_index,
        "quantity": 0
      })
    });

    return result.json();
  }
  
  
  async setNote(note) {

    const result = await fetch("/cart/update.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        note: note
      })
    });

    return result.json();
  }

  
  async clearCart() {
    const result = await fetch({
      method: "POST",
      headers: {
        "Accept": "application/json"
      }
    });

    return result.json();
  }

  
  async countCartItems() {            
    const fetchCart = await this.getCart();         
    let itemsInCartCurrently = fetchCart.item_count;
    
    return itemsInCartCurrently;

  }
   
}


class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.mobileFilters = document.querySelector('.mobile-facets__wrapper');
    //console.log("this.mobileFilters", this.mobileFilters)

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
   // element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => { this.mainDetailsToggle.classList.add('menu-opening') });
    summaryElement.setAttribute('aria-expanded', true);
   	trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.style.overflowY = "hidden";
  }

  
  closeMenuDrawer(event, elementToFocus = false) {
    document.body.style.overflowY = "scroll";
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      //document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);     
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    document.body.style.overflowY = "scroll";
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
        
    if (this.mobileFilters != undefined){
      this.mobileFilters.classList.remove('sm-0');
    }
        
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    
    if (this.mobileFilters != undefined){
      this.mobileFilters.classList.add('sm-0');
    }
    
    this.header = this.header || document.getElementById('shopify-section-header');
    //this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    //document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);


    const mediaQuery = window.matchMedia('(min-width: 48em)');
    	// Check if the media query is true
    if (mediaQuery.matches) {
      // Then 
      document.body.style.overflowY = "scroll";
    }

    else {
      document.body.style.overflowY = "hidden";
    }

  }
}
customElements.define('header-drawer', HeaderDrawer);


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
    
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } 
    
    else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
    
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);


class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);


class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}
customElements.define('deferred-media', DeferredMedia);


class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }
   
    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
    
    this.querySelectorAll('.slider-CntVisual .dot').forEach((l) => { l.classList.remove('active') })
    this.querySelector(`.slider-CntVisual .dot:nth-child(${this.currentPage})`).classList.add('active');
    
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({left: slideScrollPosition, behavior: 'smooth'});
  }
}
customElements.define('slider-component', SliderComponent);




class VariantSelects extends HTMLElement {

  constructor() {

    super();

    this.updateURL();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    //this.setCurrent();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      //this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }
  
  // setCurrent() {
  	 	 
  // }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        if(index != 1){
          return this.options[0] === option;
        }
      }).includes(false);
      
    });
    this.feedIDtoBtn(this.currentVariant)
  } 
  
  feedIDtoBtn(id) {   
    document.getElementById('atcBtn').dataset.pid = id.id;
    document.getElementById('atcBtn').dataset.sku = id.sku;
    let x = document.getElementById('atcBtn').dataset.pid;   
  }
  
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {  
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      //Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).classList.toggle('asdasd')
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios);





class VideoComponent_es extends HTMLElement {
   
  
    // >>> constructor ============
    constructor() {
      super();
      this.type = this.dataset.type;
      this.embedWrapper = this.querySelector('.embedWrapper');
      this.embedID = this.embedWrapper.dataset.id;
      this.posterWrapper = this.querySelector('.posterWrapper');
      this.posterBtn = this.posterWrapper.querySelector('.posterBtn');
      this.posterImg = this.posterWrapper.querySelector('.posterImg');
      this._addEventListener();
    }
  
  
    // >>> hook for play button ===
    _addEventListener() {
      this.posterBtn.addEventListener('click', () => {  

        //console.log(this.type)  
        if(this.type === 'yt') {
          (async () => {  
            const createYT = await this.createYTEmbed();                 
          })()
        }

        if(this.type === 'vm') {
          (async () => {  
            const createVM = await this.createVMEmbed();                 
          })()
        }

      });
    }	
  
    
    // >>> creates YT iframe ======
    async createYTEmbed() {
      let frame = document.createElement('iframe');
      frame.setAttribute('class', 'attachedIframe');
      frame.setAttribute('src', 'https://www.youtube.com/embed/'+this.embedID+'?autoplay=1');
      frame.setAttribute('width', '100%');
      frame.setAttribute('height', '100%');
      frame.setAttribute('frameborder', '0');
      frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;');
      frame.setAttribute('allowfullscreen', ''); 
      this.embedWrapper.appendChild(frame); 
      await this.hidePoster();
    }


    // >>> creates Vimeo iframe ===
    async createVMEmbed() {
      let frame = document.createElement('iframe');
      frame.setAttribute('class', 'attachedIframe');
      frame.setAttribute('src', 'https://player.vimeo.com/video/'+this.embedID+'?autoplay=1&muted=1');       
      frame.setAttribute('width', '100%');
      frame.setAttribute('height', '100%');
      frame.setAttribute('frameborder', '0');
      frame.setAttribute('allow', 'autoplay; fullscreen');       
      frame.setAttribute('allowfullscreen', '');
      this.embedWrapper.appendChild(frame);  
      await this.hidePoster();
    }


    // >>> hides user poster ======
    async hidePoster() {
      this.posterWrapper.setAttribute('aria-hidden', true);
      this.posterWrapper.classList.add('none');    
    }


}
customElements.define('video-es-component', VideoComponent_es);


class VideoComponent_lc extends HTMLElement {
     
    // >>> constructor ============
    constructor() {

      super();

      this.video = this.querySelector('video');    
      this.autoplay = this.video.autoplay;

      this.posterWrapper = this.querySelector('.posterWrapper');    
      this.posterBtn = this.querySelector('.posterBtn');

      this.playPauseBtn = this.querySelector('.playpause');
      this.stopBtn = this.querySelector('.stop');
      this.rwdBtn = this.querySelector('.rwd');
      this.fwdBtn = this.querySelector('.fwd');
      this.fullscreen = this.querySelector('.fullscreen');
      this.mute = this.querySelector('.mute');
      this.timeLabel = this.querySelector('.time');

      this._init();                    
      this.wirePlayerBtns();                    
      this.updateTime()

    }
      
  
    // >>> Initialize component ===
    _init() {                    
      //console.log('init vd-lc cmp')
      this.video.removeAttribute('controls'); 
      this.video.muted = true;  
      
      if(this.autoplay == true && (typeof(this.playPauseBtn) != 'undefined' && this.playPauseBtn != null)) {
        this.playPauseBtn.querySelector('span[aria-hidden="true"]').innerHTML = '&#9208;';
        this.playPauseBtn.setAttribute("aria-pressed", true);
        this.playPauseBtn.querySelector('span.visually-hidden').textContent = 'Playing';
      }
    }                                                   
 
 
    // >>> btn functionalities ====                                 
    wirePlayerBtns() {

      /* ===============================================
      == play: &#9654;    == stop: &#9632; =============
      == pause: &#9208;   == back: &#171; ==============
      == forward: &#187;  == speaker: &#128266; ========
      == muted: &#128263; == fullscreen: &#x26F6; ======
      =============================================== */                  


      // >>> PosterPlayBtn =============
      if(typeof(this.posterBtn) != 'undefined' && this.posterBtn != null){
        this.posterBtn.addEventListener('click', () => {
          //console.log(this)                             
          this.stopBtn.setAttribute("aria-pressed", false);
          this.posterWrapper.setAttribute('aria-hidden', true);
          this.posterWrapper.classList.add('none');
          this.video.play();
          this.playPauseBtn.querySelector('span[aria-hidden="true"]').innerHTML = '&#9208;';
          this.playPauseBtn.setAttribute("aria-pressed", true);
          this.playPauseBtn.querySelector('span.visually-hidden').textContent = 'Playing';
        })
      }



      // >>> Play ======================
      if(typeof(this.playPauseBtn) != 'undefined' && this.playPauseBtn != null){
        [this.playPauseBtn, this.video].forEach(el => {
          el.addEventListener('click', e => {

            this.stopBtn.setAttribute("aria-pressed", false);

            if(this.video.paused) {
              this.video.play();
              this.playPauseBtn.querySelector('span[aria-hidden="true"]').innerHTML = '&#9208;';
              this.playPauseBtn.setAttribute("aria-pressed", true);
              this.playPauseBtn.querySelector('span.visually-hidden').textContent = 'Playing';
            } 

            else {
              this.video.pause();
              this.playPauseBtn.querySelector('span[aria-hidden="true"]').innerHTML = '&#9654;';
              this.playPauseBtn.setAttribute("aria-pressed", false);
              this.playPauseBtn.querySelector('span.visually-hidden').textContent = 'Paused';
            } 

          })
        })
      }

      // >>> Stop ======================
      if(typeof(this.stopBtn) != 'undefined' && this.stopBtn != null){
        this.stopBtn.addEventListener('click', e => {                                                       
          this.video.pause();
          this.video.currentTime = 0;
          this.playPauseBtn.querySelector('span[aria-hidden="true"]').innerHTML = '&#9654;';
          this.stopBtn.setAttribute("aria-pressed", true);
        })
      }


      // >>> Rwd ======================= 
      if(typeof(this.rwdBtn) != 'undefined' && this.rwdBtn != null){                  
        this.rwdBtn.addEventListener('click', e => { 
          this.video.currentTime -= 3;                      
        });   
      }                                    

      // >>> Fwd =======================  
      if(typeof(this.fwdBtn) != 'undefined' && this.fwdBtn != null){                   
        this.fwdBtn.addEventListener('click', e => {   
          this.video.currentTime += 3;
          if(this.video.currentTime >= this.video.duration || this.video.paused) {
            this.video.pause();
            this.video.currentTime = 0;
            this.playPauseBtn.querySelector('span[aria-hidden="true"]').innerHTML = '&#9654;';
          }
        });
      }

      // >>> Fullscreen ================ 
      if(typeof(this.fullscreen) != 'undefined' && this.fullscreen != null){  
        this.fullscreen.addEventListener('click', e => {
          if (this.video.exitFullscreen) {
            //console.log('go small')
            this.video.exitFullscreen();
            this.fullscreen.setAttribute("aria-pressed", false);
          } 

          if (this.video.requestFullscreen) {
            //console.log('go full')
            this.video.requestFullscreen();
            this.fullscreen.setAttribute("aria-pressed", true);
          }                                        
        });
      }

      // >>> Mute ====================== 
      if(typeof(this.mute) != 'undefined' && this.mute != null){ 
        this.mute.addEventListener('click', e => {
          this.toggleMute();
        });
      }

    }                 
     
    
    // >>> Update time label ======
    updateTime() {
      this.video.addEventListener('timeupdate', e => {

        let minutes = Math.floor(this.video.currentTime / 60);
        let seconds = Math.floor(this.video.currentTime - minutes * 60);
        let minuteValue; let secondValue;

        if (minutes < 10) { minuteValue = "0" + minutes; } 
        else { minuteValue = minutes; }

        if (seconds<10) { secondValue = "0" + seconds; } 
        else { secondValue = seconds; }

        let mediaTime = minuteValue + ":" + secondValue;

        if(typeof(this.timeLabel) != 'undefined' && this.timeLabel != null){ 
          this.timeLabel.textContent = mediaTime;
        }

      });
    }
     

    // >>> Toggle mute/unmute =====
    toggleMute() {
      if(typeof(this.mute) != 'undefined' && this.mute != null){ 
        if(this.video.muted == true) {
          //console.log('is muted')
          this.video.muted = false;
          this.mute.setAttribute("aria-pressed", false);
          this.mute.querySelector('span[aria-hidden="true"]').innerHTML = '&#128266';                                              
        } else {
          //console.log('is not muted, muting')
          this.video.muted = true;
          this.mute.setAttribute("aria-pressed", true);
          this.mute.querySelector('span[aria-hidden="true"]').innerHTML = '&#128263';                                            
        }
      }
    }  


}               
customElements.define('video-lc-component', VideoComponent_lc);



class AjaxCart extends HTMLElement {
    

    constructor() {
      
        super();
        
        this.cartFunctions = new CartFunctions();

        this.cart = this;    
        this.cartContainer   = this.closest('details');
        this.cartHeader      = this.querySelector('header');
        this.cartHeaderLabel = this.cartHeader.querySelector('.label');

        this.cartOpener      = this.closest('details').querySelector('.cartToggler');
        this.cartCloser      = this.cartHeader.querySelector('.cartCloseBtn');
        
        this.itemTemplate    = this.querySelector('#cart-item-template');
        this.discountTemplate = this.querySelector('#cart-discount-template');
        this.emptyCartTemplate = this.querySelector('#emptyCartTemplate');
        this.cartProductArea = this.querySelector('.ajax-cart-product-area'); 
      
        this.checkCartOnload();
        this.open_close_events();
      
    }
    

    checkCartOnload() {        
      window.addEventListener('load', ()=> {                 
        (async() => {        
          const checkCartItems = await this.cartFunctions.countCartItems();
          if(checkCartItems == 0) {              			
            let emptyCartclone = this.emptyCartTemplate.content.cloneNode(true);              
            this.querySelector('.cartFormWrapper').classList.add('sm-0');
            this.querySelector('.ajax-cart-footer').classList.add('sm-0');
            this.appendChild(emptyCartclone);         
          }
        })()
      });    
    }
    
    
    open_close_events() { 
        
      this.cartOpener.addEventListener('click', (e) => { 

        let filtersButton = document.querySelector('.mobile-facets__wrapper');
        if (filtersButton != undefined ){
          filtersButton.classList.remove('z5');
          filtersButton.classList.add('z-1');
        }


        (async() => { 

          if(typeof(document.querySelector(".ajax-cart-product-area")) != 'undefined' && document.querySelector(".ajax-cart-product-area") != null){
            document.querySelector(".ajax-cart-product-area").innerHTML = '';
          }

          const checkCartItems = await this.cartFunctions.countCartItems();
          let cart_details = document.querySelector(".cart-details");
          let cart_footer = document.querySelector (".ajax-cart-footer");
          let cart_empty = document.querySelector (".cart_empty");


          if(checkCartItems > 0) {
                
            this.querySelector('.cartFormWrapper').classList.remove('sm-0');
            this.querySelector('.ajax-cart-footer').classList.remove('sm-0');

            let cartEmptyExists = this.querySelector(".cart_empty");

            if (cartEmptyExists != undefined){
              //console.log("cartEmptyExists", cartEmptyExists)
              cartEmptyExists.remove();
            }

            this.headerLabelMessage(checkCartItems);      
            const getCart = await this.cartFunctions.getCart();
            let totalPrice = getCart.total_price;
            let totalsValue = document.querySelector('.totals__subtotal_value');

            //totalsValue.textContent = `€${(totalPrice/100).toFixed(2)}`;
            totalsValue.textContent = `€${(totalPrice/100).toFixed(2).replace('.', ',')}`;
            //totalsValue.textContent = `${Intl.NumberFormat('en-DE', { style: 'currency', currency: 'EUR' }).format(totalPrice/100)}`;
            
            this.createItems(getCart.items); 

          } else { 
            this.headerLabelMessage(checkCartItems);         
          }             
              
          this.openDrawer(); 

        })() 

        setTimeout(() => { 
          const mediaQuery = window.matchMedia('(min-width: 48em)');      
          if (mediaQuery.matches) { document.body.style.overflowY = "scroll" }
          else { 
            document.body.style.overflowY = "hidden"; 
          }
        }, 600)

        
      }); 

      this.cartCloser.addEventListener('click', () => { 
                                        
        let filtersButton = document.querySelector('.mobile-facets__wrapper');
        if (filtersButton != undefined ){
          filtersButton.classList.remove('z-1');
          filtersButton.classList.add('z5');
        }                                                              
                                        
        this.closeDrawer();
        document.body.style.overflowY = "scroll";
        setTimeout(() => { 
          if(typeof(document.querySelector(".ajax-cart-product-area")) != 'undefined' && document.querySelector(".ajax-cart-product-area") != null){
              document.querySelector(".ajax-cart-product-area").innerHTML = '';
          }
        }, 10)
        
      });   

    }
  

    createItems(items) {
    
      let cnt = 1;
      items.forEach((item) => {
        
        let clone = this.itemTemplate.content.cloneNode(true);
      
        //console.log("w/o properties")
        let {
          variant_id,
          url: productURL,
          product_title,
          variant_title,
          quantity,
          final_price,
          original_price,
          final_line_price,
          original_line_price,
          discounts,
          //discounted_price,
          featured_image: {alt},
          featured_image: {url: fimgURL},
          featured_image: {width},
          featured_image: {height}
        } = item;
        
        
        clone.querySelector('img').alt = `${alt}`;
        clone.querySelector('img').width = `${width}`;
        clone.querySelector('img').height = `${height}`;
        clone.querySelector('img').src = `${fimgURL}`;
        clone.querySelector('.cart-item').id = `CartItem-${cnt}`;
        clone.querySelector('.item-title').textContent = `${product_title}`;

        if (clone.querySelector('.item-title').textContent != 'GIFT CARD'){
          clone.querySelector('.variant-title').textContent = `${variant_title}`;
        }

        clone.querySelector('.cart-item').dataset.id = `${variant_id}`;
        // 1-based line index. Cart mutations must go by line, not variant: an
        // automatic BOGO discount splits one variant across several lines (one
        // unit at 100% off, the rest at full price) that share a variant_id.
        clone.querySelector('.cart-item').dataset.line = `${cnt}`;
        clone.querySelector('a').href = `${productURL}`;
   
        // Prefer the line-level totals so any automatic (line) discount is
        // reflected: final_line_price is the price after the discount, and
        // original_line_price the price before it. Fall back to per-unit * qty.
        const finalLine = (final_line_price != null) ? final_line_price : final_price * quantity;
        const originalLine = (original_line_price != null) ? original_line_price : (original_price != null ? original_price * quantity : finalLine);

        const finalPriceEl = clone.querySelector('.final-price');
        const originalPriceEl = clone.querySelector('.original-price');

        finalPriceEl.textContent = `€${(finalLine/100).toFixed(2).replace('.', ',')}`;

        // Show the struck-through "before" price + discount copy only when the
        // cart actually applied a discount to this line.
        if (originalLine > finalLine) {
          originalPriceEl.textContent = `€${(originalLine/100).toFixed(2).replace('.', ',')}`;
          originalPriceEl.classList.remove('none');
          this.renderItemDiscounts(clone, discounts);
        }

        clone.querySelector('label').htmlFor= `Quantity-${cnt}`;
        clone.querySelector('input').id = `Quantity-${cnt}`;
        clone.querySelector('input').value = `${quantity}`;
        // Per-unit final price kept for the quantity handlers to recompute the total.
        finalPriceEl.dataset.value = final_price;

        this.cartProductArea.appendChild(clone);
        let thisItem = this.querySelector(`#CartItem-${cnt}`);
        this.attatchItemHandlers(thisItem);
        cnt++;

      })
    }


    // Render one line per applied discount (title + icon) beneath the price.
    // Only discounts worth money: Shopify also attaches a discount to the units
    // that merely *trigger* a BOGO (the "Buy X" side) with amount 0 — bookkeeping
    // that would otherwise print a badge on a full-price line.
    renderItemDiscounts(clone, discounts) {
      const list = clone.querySelector('.item-discounts');
      if (!list || !this.discountTemplate) return;
      const applied = (discounts || []).filter((discount) => discount && discount.title && discount.amount > 0);
      if (!applied.length) return;

      applied.forEach((discount) => {
        const row = this.discountTemplate.content.cloneNode(true);
        row.querySelector('.discount-title').textContent = discount.title;
        list.appendChild(row);
      });
      list.classList.remove('none');
    }


    // Repaint the whole product area from a cart payload — the single source of
    // truth after any mutation.
    //
    // Rows are rebuilt rather than patched in place because the cart's shape can
    // change in ways a per-row patch can't express: an automatic BOGO discount
    // splits one variant across several lines (one unit at 100% off, the rest at
    // full price), lines merge back together, and every line index shifts when a
    // line is removed. Matching rows to items by variant_id is ambiguous exactly
    // when it matters most, so rebuild from the cart's own line order.
    renderCart(cart) {
      const items = (cart && cart.items) || [];
      const itemCount = (cart && cart.item_count) || 0;

      this.cartProductArea.innerHTML = '';

      const totalsValue = document.querySelector('.totals__subtotal_value');
      if (totalsValue) {
        totalsValue.textContent = `€${(((cart && cart.total_price) || 0)/100).toFixed(2).replace('.', ',')}`;
      }

      const cartBubble = document.querySelector('.cart-count-bubble span');
      if (cartBubble) cartBubble.textContent = itemCount;

      this.headerLabelMessage(itemCount);

      const existingEmpty = this.querySelector('.cart_empty');
      if (itemCount === 0) {
        const cartLabel = document.querySelector('.cart_label');
        if (cartLabel) { cartLabel.classList.remove('pfDin'); cartLabel.classList.add('bold'); }
        if (!existingEmpty) {
          const emptyCartclone = this.emptyCartTemplate.content.cloneNode(true);
          this.querySelector('.cartFormWrapper').classList.add('sm-0');
          this.querySelector('.ajax-cart-footer').classList.add('sm-0');
          this.appendChild(emptyCartclone);
        }
      } else {
        if (existingEmpty) existingEmpty.remove();
        this.querySelector('.cartFormWrapper').classList.remove('sm-0');
        this.querySelector('.ajax-cart-footer').classList.remove('sm-0');
        this.createItems(items);
      }

      // A cart change can flip whether the gift is unlocked/discounted.
      this.refreshGiftStatus();
    }

    // Cart writes must not overlap: fast +/- clicks fire a change per step, and
    // concurrent change.json calls can resolve out of order, leaving the drawer
    // painted from an older cart than the one that landed last. Chain them so
    // each write (and its repaint) completes before the next starts.
    enqueueCartWrite(task) {
      this.cartWriteChain = (this.cartWriteChain || Promise.resolve())
        .then(task, task)
        .catch((error) => console.error('[cart] update failed', error));
      return this.cartWriteChain;
    }

    // Re-run the free-gift eligibility check (trigger button + progress bar).
    // Called directly rather than relying on the subtotal mutation observer,
    // which never fires when the gift nets €0 and the subtotal text is unchanged.
    refreshGiftStatus() {
      const giftModal = document.querySelector('free-gift-modal');
      if (giftModal && typeof giftModal.evaluate === 'function') giftModal.evaluate();
    }


    attatchItemHandlers(thisItem) {

      let removeButton = thisItem.querySelector('.remove');
      let qtyMainInput = thisItem.querySelector('.quantity__input');

      // Mutations go by LINE, not variant id: a split variant (BOGO) puts the same
      // variant_id on several lines, and Shopify 400s on an ambiguous id change.
      // Read the line at event time — renderCart re-stamps it on every repaint.
      const currentLine = () => Number(thisItem.dataset.line);

      // Resolve a cart to paint from: change.json already returns the updated
      // cart, so only re-fetch if it handed back an error payload (no items).
      const cartFrom = async (response) =>
        (response && response.items) ? response : await this.cartFunctions.getCart();

      removeButton.addEventListener('click', () => {
        this.enqueueCartWrite(async () => {
          const updated = await this.cartFunctions.removeItemByLine(currentLine());
          this.renderCart(await cartFrom(updated));
        });
      })

      // Fires for BOTH manual edits and the +/- buttons: <quantity-input>
      // dispatches a 'change' on this input after stepping the value, so this
      // single handler is the one place that persists a quantity change.
      // No optimistic repaint: with a split line the client can't predict how
      // Shopify will re-allocate the discount, so the returned cart is the truth.
      qtyMainInput.addEventListener('change', () => {
        const qtyMainInputVal = Number(qtyMainInput.value);
        this.enqueueCartWrite(async () => {
          const updated = await this.cartFunctions.updateItemByLine(currentLine(), qtyMainInputVal);
          this.renderCart(await cartFrom(updated));
        });
      })

    }
    

    headerLabelMessage(x) {
      x > 0 ? this.cartHeaderLabel.textContent = 'Έχεις επιλέξει' : this.cartHeaderLabel.textContent = 'Το καλάθι σου'
    }
     
    
    closeDrawer() {
      this.classList.remove('slideIn');    
      setTimeout(()=>{
        this.cartContainer.removeAttribute('open');         
      },333)                
    }
  

    openDrawer() {
      setTimeout(()=>{ this.classList.add('slideIn')},10)   
    }
   

}
customElements.define('ajax-cart', AjaxCart);



class GdprBeforeCheckout extends HTMLElement {
    
  constructor() {
    super();
    
    this.boxWrap = this.querySelector('.gdprBox');
    this.input = this.querySelector('input[type="checkbox"]');        
    this.warning = this.querySelector('.gdpr-checkout-warning');
    this.checkoutBtn = document.querySelector('#checkout');    
    this.preventer = document.querySelector('.preventer');
    this.debouncedOnChange = debounce((event) => {
      this.checkGDPR(event);
    }, 100);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
    window.addEventListener('load', this.debouncedOnChange.bind(this));
    this.preventer.addEventListener('click', this.debouncedOnChange.bind(this));   
    
  }
  
  checkGDPR(event) { 
    
    if(this.input.checked){
      this.checkoutBtn.classList.remove('not-allowed');
      this.checkoutBtn.classList.add('pointer');
      this.checkoutBtn.disabled = false;            
      this.warning.classList.add('none'); 
      this.preventer.classList.add('none');
      this.boxWrap.classList.add('border-black');      
    }
    
  	else {               
      if(event.type === 'click') {
        this.preventer.classList.add('not-allowed');
        this.preventer.classList.remove('pointer');
        this.warning.classList.remove('none'); 
      }
      
      this.checkoutBtn.disabled = true; 
      this.preventer.classList.remove('none');
      this.preventer.classList.add('block');

    }   
  } 
  
}
customElements.define('gdpr-checkout', GdprBeforeCheckout);


class SeenLately extends HTMLElement {
   
  
  constructor() {    
    super();    
    this.productsLoaded = false; 
    this.box = this;    
    this.seenList  = this.querySelector('.seen-list');    
    this.sentinel = document.getElementById('seenLately_sentinel'); 
    this.seen_options = { root: null, rootMargin: '0px 0px -50% 0px' }
    this.item_options = { root: null, rootMargin: "0px", threshold: 0.7 };    
    this.itemTemplate = this.querySelector('#product-card-template'); 
    this.priceNormalTemplate = this.querySelector('#price-normal-template'); 
    this.priceSaleTemplate = this.querySelector('#price-sale-template');    
    this.toggleBtn = this.querySelector('.toggleSeenListBtn');
    this.checkPage();
    
    if (!mq_sm.matches){
      this.createSeenObserverDesktop();
    } else {
      this.createSeenObserver();
    }
    
  }

  
  checkPage() {
    
    if (window.location.href.indexOf("/products/") > -1) {      
      let ls_exists = this.checkStorage();
      let prod =  document.querySelector('.js-product-main')
      let prodid = prod.dataset.id; 
      let prodHandle = prod.dataset.handle;  
      let seenIDs = [{ "id": prodid, "handle": prodHandle }];

      if(ls_exists === false) {
        this.setStorage(seenIDs);
      } 
      
      if (ls_exists === true) {             
        let idList = this.getStorage();
        this.updateList(prodid, prodHandle, idList);                   
      }    
  	}    
  }  
  
  
  createSeenItem(itemProps) {
      
    //console.log(itemProps)
    
    if(itemProps.available === true) {
      let clone = this.itemTemplate.content.cloneNode(true);  
      clone.querySelectorAll('a').forEach((link)=>{ link.href = `${itemProps.url}` });
      clone.querySelector('.product-card-title').textContent = `${itemProps.title}`;

      let img = document.createElement('IMG');
      img.classList.add('featured', 'absolute', 'top-0', 'left-0', 'w-p100', 'h-p100', 'object-cover', 'object-center', 'transition-linear');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'auto');
      clone.querySelector('.product-card-media').innerHTML = '';
      clone.querySelector('.product-card-media').append(img);   
      
      if(itemProps.media[0].media_type == 'video') {
        itemProps.media[1].alt !== null ? clone.querySelector('img').alt = `${itemProps.media[1].alt}` : clone.querySelector('img').alt = `${itemProps.title}`;     
        clone.querySelector('img').width = `${itemProps.media[1].width}`;
        clone.querySelector('img').height = `${itemProps.media[1].height}`;
        clone.querySelector('img').src = `${itemProps.media[1].src}`; 
      } else {
       	itemProps.media[0].alt !== null ? clone.querySelector('img').alt = `${itemProps.media[0].alt}` : clone.querySelector('img').alt = `${itemProps.title}`;     
        clone.querySelector('img').width = `${itemProps.media[0].width}`;
        clone.querySelector('img').height = `${itemProps.media[0].height}`;
        clone.querySelector('img').src = `${itemProps.media[0].src}`; 
      }
      
      

      if(itemProps.compare_at_price != null){
        let price_cat = this.priceSaleTemplate.content.cloneNode(true);
        price_cat.querySelector('.price-compare s').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(itemProps.compare_at_price / 100)}`; 
        price_cat.querySelector('.price-item-sale span').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(itemProps.price / 100)}`;
        clone.querySelector('.price-and-newtag .price-wrapper').innerHTML = '';
        clone.querySelector('.price-and-newtag .price-wrapper').append(price_cat);

      } 

      else {
        let price_nrm = this.priceNormalTemplate.content.cloneNode(true);      
        price_nrm.querySelector('.price-regular .price-item-regular').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(itemProps.price / 100)}`;
        clone.querySelector('.price-and-newtag .price-wrapper').innerHTML = '';
        clone.querySelector('.price-and-newtag .price-wrapper').append(price_nrm);
      }

      const onSaleBadge = clone.querySelector('.price-and-newtag .onSale');
      if (onSaleBadge) {
        onSaleBadge.style.display = "none";
      }
      const newBadge = clone.querySelector('.price-and-newtag .isNew');
      if (newBadge) {
        newBadge.style.display = "none";
      }
      clone.querySelector('.pCardDetails').style.minHeight = 'initial';
      clone.querySelectorAll('.color-black').forEach((i) => { i.style.color = "#ffffff";  });
      clone.querySelectorAll('.txt-18, .txt-16').forEach((i) => { i.classList.add('txt-14', 'md-txt-18'); });

      this.seenList.append(clone) 
      
    }
    
  } 
  
  
  handleSeenCallback(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.productsLoaded) { // Check if products are already loaded
        if(typeof(this) != 'undefined' && this != null){ 
          let retrievedList = this.getStorage();
          if(retrievedList.length > 1) {
            this.classList.add('seenReadyState');
            this.classList.remove('seenIdleState');
            setTimeout(() =>{ this.classList.add('slideIn') }, 150);
          
            if (mq_sm.matches){
              setTimeout(() =>{ this.attachControlsEvents() }, 50);
            }
            
            // Use a Set to track displayed handles
            let displayedHandles = new Set();
  
            retrievedList.forEach((item) => {
              if (!displayedHandles.has(item.handle)) {
                fetch(`${item.handle}.js`)
                  .then(response => {
                    if (!response.ok) {
                      // Remove the item from local storage if it's not available
                      this.removeFromStorage(item.handle);
                      return null;
                    }
                    return response.text();
                  })
                  .then(text => {
                    if (text) {
                      let itemProps = JSON.parse(text);
                      this.createSeenItem(itemProps);
                      // Add handle to the Set
                      displayedHandles.add(item.handle);
                    }
                  });
              }
            });
  
            // Set the flag to true after products are loaded
            this.productsLoaded = true;
          }
        }
      }
    });
  }
  
  
  createSeenObserver() {  
    let seen_animationObs = new IntersectionObserver(this.handleSeenCallback.bind(this), this.seen_options);  
    seen_animationObs.observe(this.sentinel);    
  }
  
  
  createSeenObserverDesktop() {
    let seen_animationObsD = new IntersectionObserver(this.handleSeenCallback.bind(this), this.seen_options);  
    seen_animationObsD.observe(this);   
  }
  
  
  attachControlsEvents() {        
    this.toggleBtn.addEventListener('click', () => {
      this.toggleAnimation();  
      if (!mq_sm.matches){
        this.toggleBtn.removeAttribute('aria-expanded');
        this.toggleBtn.removeAttribute('aria-pressed');
      } else {
      	this.toggleBtnState(); 
      }
    });    
  }
  
  
  toggleBtnState() {
    if(this.toggleBtn.getAttribute('aria-expanded') === 'false') {
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      this.toggleBtn.setAttribute('aria-pressed', 'true');
      this.toggleBtn.querySelector('.toggle-closeLbl').classList.remove('opacity-0');
    } else {
      this.toggleBtn.setAttribute('aria-expanded', 'false');
      this.toggleBtn.setAttribute('aria-pressed', 'false');
      this.toggleBtn.querySelector('.toggle-closeLbl').classList.add('opacity-0');
    }
  }
  

  toggleAnimation() {
    this.classList.toggle('expandUp');   
  }
 

  checkProductID_inStorage(prodid) {    
    let retrievedList = this.getStorage();
    const checkID = obj => obj.id === `${prodid}`;
    const inStorageResult = retrievedList.some(checkID);
    return inStorageResult;     
  }

  removeFromStorage(handle) {
    let retrievedList = this.getStorage();
    let updatedList = retrievedList.filter(item => item.handle !== handle);
    this.setStorage(updatedList);
  }
  
  updateList(prodid, prodHandle, parsedObject) {    
    // Check if the product is already in the list
    const checkID = obj => obj.id === `${prodid}`;
    const inStorageResult = parsedObject.some(checkID);
    
    if (!inStorageResult) {
      let t = { "id": prodid, "handle": prodHandle }; 
      parsedObject.unshift(t);
      this.setStorage(parsedObject);  
    }
  }
 
  checkStorage() {
    if (localStorage.getItem('seen-list') !== null) {
      return true;
    } else {
      return false;
    }
  }

  getStorage() {    
    let retrievedIDObject = localStorage.getItem('seen-list');   
    let parsedObject = JSON.parse(retrievedIDObject); 
    return parsedObject;    
  }
 

  setStorage(ids_object) {   
    localStorage.setItem('seen-list', JSON.stringify(ids_object));
  }


}
customElements.define('seen-lately-component', SeenLately);


function footerMenusDesktop() {
  let footerMenus = document.querySelectorAll('.footer-details');
  footerMenus.forEach((fmenu) =>{ fmenu.setAttribute('open', '') })
}


if (!mq_sm.matches){
  footerMenusDesktop();
}       




  



